import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import { SketchPicker } from "react-color";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getUom } from "../../../store/uom/action";
import { getCivilAccountCategory, resetCivilAccountCategoryState } from "../../../store/civilAccountCategory/action";
import { getCivilAccount as onGetCivilAccounts, addNewCivilAccount as onAddNewCivilAccount, updateCivilAccount as onUpdateCivilAccount, deleteCivilAccount as onDeleteCivilAccount, getCivilAccountLoading, resetCivilAccountState } from "../../../store/civilAccount/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const BudgetAccountItems = () => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();
  const [color, setColor] = useState("#FFAA00");

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, branches, branchLoading, uoms, uomLoading, civilAccounts, isCivilAccountCreated, isCivilAccountSuccess, loading, error, companies, companyLoading, clients, clientLoading, civilAccountCategories, civilAccountCategoryLoading, civilAccountCloses, isCivilAccountCloseCreated, civilAccountClosesLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilAccounts: state.CivilAccount.civilAccounts,
    loading: state.CivilAccount.loading,
    isCivilAccountCreated: state.CivilAccount.isCivilAccountCreated,
    isCivilAccountSuccess: state.CivilAccount.isCivilAccountSuccess,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    civilAccountCategories: state.CivilAccountCategory.civilAccountCategories,
    civilAccountCategoryLoading: state.CivilAccountCategory.loading,
    error: state.CivilAccount.error,
    uoms: state.Uom.uoms,
    uomLoading: state.Uom.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    // civilAccountCloses: state.CivilAccountClose.civilAccountCloses,
    // isCivilAccountCloseCreated: state.CivilAccountClose.isCivilAccountCloseCreated,
    // civilAccountClosesLoading: state.CivilAccountClose.loading
  }));

  const [civilAccountList, setCivilAccountList] = useState([]);
  const [civilAccount, setCivilAccount] = useState([]);
  const [civilAccountClose, setCivilAccountClose] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchSearchList, setBranchSearchList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [civilAccountCategoryList, setCivilAccountCategoryList] = useState([]);
  const [modalClose, setModalClose] = useState(false);
  const [modalBalance, setModalBalance] = useState(false);
  const [printDoc, setPrintDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [inputDate, setInputDate] = useState("");
  const [tableItem, setTableItem] = useState([]);

  const onClickDelete = (civilAccount) => {
    setCivilAccount(civilAccount);
    setDeleteModal(true);
  };

  const handleDeleteCivilAccount = () => {
    if (civilAccount) {
      dispatch(onDeleteCivilAccount(civilAccount));
      setDeleteModal(false);
    }
  };

  // useEffect(() => {
  //   setCivilAccountList(civilAccounts);
  // }, [civilAccounts]);

  useEffect(() => {
    if (!isEmpty(civilAccounts)) {
      let filteredCivilAccounts = civilAccounts;
      if (activeTypeTab !== "all") {
        filteredCivilAccounts = civilAccounts.filter((civilAccount) => civilAccount.cvl_account_status.name === activeTypeTab);
      }
      setCivilAccountList(filteredCivilAccounts.map((el) => ({ ...el, isChecked: false })));
    }
  }, [civilAccounts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "cvl_account_category",
        label: "Kategori Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "cvl_account_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "sort_order",
        label: "Urutan",
        isSelected: true,
        data: [],
      },
    ];

    if (civilAccountList.length > 0) {
      civilAccountList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "cvl_account_branch") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "cvl_account_category") {
                const type = dataDoc.find((d) => d.id === "type");
                type.data.push(value?.type ?? "-");
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [civilAccountList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredCivilAccounts = civilAccounts;
      if (type !== "all") {
        filteredCivilAccounts = civilAccounts.filter((civilAccount) => civilAccount.cvl_account_status.name === type);
      }
      setCivilAccountList(filteredCivilAccounts);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      setSearchValue("");
      dispatch(onGetCivilAccounts({ branchId: branchSelected?.value ?? "" }));
      dispatch(getUom());
      handleGetCivilAccountCategory(branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const handleGetCivilAccountCategory = (branchId) => {
    dispatch(resetCivilAccountCategoryState());
    dispatch(getCivilAccountCategory({ branchId: branchId }));
  };

  useEffect(() => {
    setCivilAccount(civilAccounts);
  }, [civilAccounts]);

  useEffect(() => {
    if (!isEmpty(civilAccounts)) {
      setCivilAccount(civilAccounts);
      setIsEdit(false);
    }
  }, [civilAccounts]);

  useEffect(() => {
    if (!isEmpty(civilAccountCategories)) {
      var civilAccountCategoryData = [];
      var opt = [];
      civilAccountCategories.forEach((item, key) => {
        const name = item.name;
        const type = item.type;
        const id = item.id;
        var obj = { label: name + " / " + type, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      civilAccountCategoryData.push(option);
      setCivilAccountCategoryList(civilAccountCategoryData);
    }
  }, [civilAccountCategories]);

  useEffect(() => {
    var data = [];
    let dataSearch = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    var optionSearch = { options: [{ label: "Semua Cabang", value: "" }, ...opt] };
    data.push(option);
    dataSearch.push(optionSearch);

    if (branches.length > 0) {
      setBranchList(data);
      setBranchSearchList(dataSearch);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCivilAccount(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handleColorChangeComplete = (color) => {
    setColor(color.hex);
  };

  const handleCivilAccountClick = useCallback(
    (arg, isCopy) => {
      const civilAccount = arg;
      if (civilAccount.color) setColor(civilAccount.color);
      setCivilAccount({
        id: civilAccount.id,
        name: civilAccount.name,
        code: civilAccount.code,
        sinceat: civilAccount.sinceat,
        color: civilAccount.color,
        description: civilAccount.description,
        sortOrder: civilAccount.sort_order,
        status: civilAccount.cvl_account_status.id,
        company:
          civilAccount.cvl_account_company === null
            ? ""
            : {
                label: civilAccount.cvl_account_company ? civilAccount.cvl_account_company.name : "",
                value: civilAccount.cvl_account_company ? civilAccount.cvl_account_company.id : "",
              },
        client:
          civilAccount.cvl_account_client === null
            ? ""
            : {
                label: civilAccount.cvl_account_client ? civilAccount.cvl_account_client.name : "",
                value: civilAccount.cvl_account_client ? civilAccount.cvl_account_client.id : "",
              },
        branch:
          civilAccount.cvl_account_branch === null
            ? ""
            : {
                label: civilAccount.cvl_account_branch ? civilAccount.cvl_account_branch.name : "",
                value: civilAccount.cvl_account_branch ? civilAccount.cvl_account_branch.id : "",
              },
        uom:
          civilAccount.cvl_account_uom === null
            ? ""
            : {
                label: civilAccount.cvl_account_uom ? civilAccount.cvl_account_uom.name : "",
                value: civilAccount.cvl_account_uom ? civilAccount.cvl_account_uom.id : "",
              },
        category: civilAccount.cvl_account_category === null ? "" : { label: civilAccount.cvl_account_category.name + " / " + civilAccount.cvl_account_category.type, value: civilAccount.cvl_account_category.id },
      });

      setIsEdit(isCopy);
      toggle();
    },
    [toggle, userType]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (civilAccount && civilAccount.client) || clientSelected,
      company: (civilAccount && civilAccount.company) || companySelected,
      branch: (civilAccount && civilAccount.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      name: (civilAccount && civilAccount.name) ?? "",
      code: (civilAccount && civilAccount.code) ?? "",
      color: (civilAccount && civilAccount.color) ?? "",
      status: (civilAccount && civilAccount.status) || "1",
      description: (civilAccount && civilAccount.description) ?? "",
      category: (civilAccount && civilAccount.category) ?? "",
      sortOrder: (civilAccount && civilAccount.sortOrder) ?? "",
      uom: (civilAccount && civilAccount.uom) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter CivilAccount Name"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      company: Yup.object().required("Please Select Company"),
      category: Yup.object().required("Please Select CivilAccountCategory"),
    }),
    onSubmit: (values) => {
      dispatch(getCivilAccountLoading());
      if (isEdit) {
        const updateCivilAccount = {
          id: civilAccount ? civilAccount.id : 0,
          name: values.name,
          code: values.code,
          branchId: values.branch.value,
          categoryId: values.category.value,
          sort_order: values.sortOrder,
          description: values.description,
          color: color,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
          uomId: values.uom.value,
        };
        dispatch(onUpdateCivilAccount(updateCivilAccount));
        validation.resetForm();
      } else {
        const newCivilAccount = {
          name: values.name,
          code: values.code,
          branchId: values.branch.value,
          categoryId: values.category.value,
          sort_order: values.sortOrder,
          description: values.description,
          color: color,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
          uomId: values.uom.value,
        };
        dispatch(onAddNewCivilAccount(newCivilAccount));
        validation.resetForm();
      }
      toggle();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilAccount(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = civilAccountList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCivilAccountList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = civilAccountList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setCivilAccountList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("createCivilAccount") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilAccountClick(data, false);
                    }}
                  >
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateCivilAccount") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilAccountClick(data, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteCivilAccount") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (cell) => {
          return (
            <div className="fw-semibold">
              <em style={{ background: cell.row.original.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>&nbsp;</em> {cell.value}
            </div>
          );
        },
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "Kategori Anggaran",
        accessor: "cvl_account_category.name",
        filterable: true,
      },
      {
        Header: "Jenis Anggaran",
        accessor: "cvl_account_category.type",
        filterable: true,
        Cell: (data) => {
          let stat;
          let statName = data.row.original.cvl_account_category ? data.row.original.cvl_account_category.type : "";
          switch (statName) {
            case "BANGUNAN":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "INFRASTRUKTUR":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            case "UPAH":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
          }
          return <div className="hstack gap-2">{stat}</div>;
        },
      },
      {
        Header: "Cabang",
        accessor: "cvl_account_branch.name",
        filterable: true,
      },
      {
        Header: "Urutan",
        accessor: "sort_order",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "cvl_account_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [handleCivilAccountClick, civilAccountList, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = civilAccountList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setCivilAccountList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => civilAccountList, [civilAccountList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  // const onChange = useAsyncDebounce((value) => {
  //   setGlobalFilter(value || undefined);
  // }, 600);

  function handleCivilAccountStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value ?? "",
    };
    dispatch(resetCivilAccountState());
    setCivilAccountList([]);
    dispatch(onGetCivilAccounts(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setCivilAccountCategoryList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(onGetCivilAccounts({ branchId: branchSelected?.value ?? "" }));
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(uoms)) {
      var data = [];
      var opt = [];
      uoms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUomList(data);
    }
  }, [uoms]);

  document.title = "Item Anggaran | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={civilAccountList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCivilAccount} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Teknik" pageTitle="Data Item Anggaran" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilAccount") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteCivilAccount") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="civilAccountList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL ACCOUNTS
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Item Anggaran" : "Tambah Anggaran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client" className="form-label">
                              Grup Usaha
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                setCivilAccountCategoryList([]);
                                validation.setFieldValue("category", "");
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                            {validation.touched.client && validation.errors.client ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.client}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company" className="form-label">
                              Perusahaan
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                setBranchList([]);
                                setCivilAccountCategoryList([]);
                                validation.setFieldValue("branch", "");
                                validation.setFieldValue("category", "");
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                            {validation.touched.company && validation.errors.company ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.company}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company" className="form-label">
                              Cabang
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Cabang"
                              onChange={(e) => {
                                setCivilAccountCategoryList([]);
                                validation.setFieldValue("category", "");
                                validation.setFieldValue("branch", e);
                                handleGetCivilAccountCategory(e.value);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.branch}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="category" className="form-label">
                              Kategori anggaran
                            </Label>
                            <Select
                              name="category"
                              value={validation.values.category}
                              placeholder="Pilih Kategori Anggaran"
                              onChange={(e) => {
                                validation.setFieldValue("category", e);
                              }}
                              options={civilAccountCategoryList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="uom" className="form-label">
                              Satuan
                              {uomLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="uom"
                              value={validation.values.uom}
                              placeholder="Pilih Satuan"
                              onChange={(e) => {
                                validation.setFieldValue("uom", e);
                              }}
                              options={uomList}
                            ></Select>
                            {validation.touched.uom && validation.errors.uom ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.uom}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="sortOrder-field" className="form-label">
                              No Urut
                            </Label>
                            <Input name="sortOrder" id="sortOrder-field" className="form-control" placeholder="Isi No Urut" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sortOrder} invalid={validation.touched.sortOrder && validation.errors.sortOrder ? true : false} />
                            {validation.touched.sortOrder && validation.errors.sortOrder ? <FormFeedback type="invalid">{validation.errors.sortOrder}</FormFeedback> : null}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="sortOrder-field" className="form-label">
                              Warna
                            </Label>
                            <SketchPicker
                              color={color}
                              onChangeComplete={(e) => {
                                handleColorChangeComplete(e);
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Input name="status" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.status}>
                              {statusActiveData.map((item, key) => (
                                <React.Fragment key={key}>
                                  {item.options.map((item, key) => (
                                    <option value={item.value} key={key}>
                                      {item.label}
                                    </option>
                                  ))}
                                </React.Fragment>
                              ))}
                            </Input>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={5} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                {/* <Modal id="showModal" isOpen={modalClose} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleClose}>
                    {"Beginning Balance"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="cclient" className="form-label">
                              Client
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="cclient"
                              value={validationClose.values.cclient}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validationClose.setFieldValue("cclient", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                            {validationClose.touched.cclient && validationClose.errors.cclient && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.cclient}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="ccompany" className="form-label">
                              Company
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="ccompany"
                              value={validationClose.values.ccompany}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validationClose.setFieldValue("ccompany", e);
                                dispatch(resetCivilAccountState());
                                dispatch(onGetCivilAccounts({ companyId: e.value }));
                              }}
                              options={companyList}></Select>
                            {validationClose.touched.ccompany && validationClose.errors.ccompany && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.ccompany}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Date
                            </Label>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Closing date"
                                options={{
                                  mode: "single",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setInputDate(dateStr);
                                }}
                                value={validationClose.values.date}/><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleClose();
                          }}>Tutup</button>
                        <button type="button" className="btn btn-success" onClick={() => {
                          toggleBalance()
                          handleItem()
                        }}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Create Balance"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal> */}
                {/* <Modal id="showModal" isOpen={modalBalance} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleBalance}>
                    {"Beginning Balance"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                        <thead>
                          <tr>
                            <td>
                              Akun
                            </td>
                            <td>
                              Nama Akun
                            </td>
                            <td>
                            </td>
                            <td >
                              Debit
                            </td>
                            <td>
                              Kredit
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {tableItem.map((item, idxAccount) => {
                            let labelDC = '';
                            switch (item.default) {
                              case "CREDIT":
                                labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                break;
                              case "DEBIT":
                                labelDC = <span className="badge text-uppercase badge-soft-success"> {item.default} </span>;
                                break;
                              default:
                                labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                break;
                            }

                            return (
                              <tr key={'idxAccount' + idxAccount}>
                                <td>
                                  {item.code}
                                </td>
                                <td>
                                  {item.name}
                                </td>
                                <td>
                                  {labelDC}
                                </td>
                                <td className="text-end">
                                  <Input
                                    name='debit'
                                    id='debit-field'
                                    className='form-control'
                                    placeholder="Enter Debit"
                                    type='number'
                                    onChange={(e) => {
                                      validationClose.setFieldValue(
                                        `tableItem[idxAccount].debit`,
                                        e.target.value
                                      );
                                      tableItem[idxAccount].debit =
                                        e.target.value;
                                    }}
                                    onBlur={validationClose.handleBlur}
                                    value={tableItem[idxAccount].debit} />
                                </td>
                                <td className="text-end">
                                  <Input
                                    name='credit'
                                    id='credit-field'
                                    className='form-control'
                                    placeholder="Enter Credit"
                                    type='number'
                                    onChange={(e) => {
                                      validationClose.setFieldValue(
                                        `tableItem[idxAccount].credit`,
                                        e.target.value
                                      );
                                      tableItem[idxAccount].credit =
                                        e.target.value;
                                    }}
                                    onBlur={validationClose.handleBlur}
                                    value={tableItem[idxAccount].credit} />
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>

                      </Table>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              toggleBalance();
                            }}>Tutup</button>
                          <button type="submit" className="btn btn-success" >
                            <span className="d-flex align-items-center">
                              <span className="flex-grow-1 me-2">{"Save"}</span>
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div></ModalBody>
                  </Form>
                </Modal> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BudgetAccountItems;
